export { canCompress, buildCompressionFunction } from './main';
